<script>
    import {PRConnect} from "@projectroom/ui-lib";
    import Select from 'svelte-select';
    import {onDestroy, onMount, afterUpdate, tick} from 'svelte';
    import axios from "axios";
	import { _ } from 'svelte-i18n';
    import { iframeRefStore } from './../store/iframe-store.js';

    export let chat;
	
	let refIframe;
	let content;
	let isQuestionLoad = false;	
	// let rawUserContent = "";


	afterUpdate(() => {
		
	});
	    
    onMount( async () => {
		
		refIframe = iframeRefStore.get();
		content = new Content({			
			rawUserContent:"undefined",
			contentType:"unknown",
			contentMemory:"undefined"
		});						
		
		PRConnect.send("/api/Content/getContentInfo", { chatId:chat.chatId }, async (response) => {
            if( response.header.status === "success") {
				console.log("getContentInfo success, response : ", response)						
				const questionInfo = response.result.questionInfo;
				const rawUserContentInfo = response.result.rawUserContentInfo;
				console.log("rawUserContentInfo.rawUserContent : ", rawUserContentInfo.rawUserContent )
				console.log("questionInfo : ", questionInfo )

				content = new Content({					
					rawUserContent:rawUserContentInfo.rawUserContent,
					contentType:questionInfo.contentType ?? "unknown",
					contentMemory:rawUserContentInfo.memory
				});						
								
				if ( questionInfo.questions.length > 0 ) {
					console.log("ALL CONTENT LOADED : ", questionInfo );
					content.contentSummary 	= questionInfo.summary;
					content.questionList 	= questionInfo.questions;
					content.resultList 		= questionInfo.results;
					content.resultDesc 		= questionInfo.resultDesc;
					isQuestionLoad = true;
				}
				content.assign();

				await tick();	// 기다려서 할 거 있으면 하자.

				console.log("ALL CONTENT LOADED : ", content.questionList );

				const textareas = document.querySelectorAll('.content-builder-textarea');
				// console.log(" selected textareas : ", textareas)
				textareas.forEach( textarea => {					
					autoResize(textarea);					
				});
				
				
				// iframeRefStore.set(refIframe);

			} else {
				console.log("getContentInfo FAIL : ", data)
			}
		});
		// <
				
            		

    });

	class Content {
		constructor({			
			rawUserContent = "",
			contentType = "",
			contentMemory = "",
			contentSummary = "",
			questionList = [],
			resultList = [],
			resultDesc = "",
		}) {			
			this.rawUserContent = rawUserContent;
			this.contentType = contentType;
			this.contentMemory = contentMemory;
			this.contentSummary = contentSummary;
			this.questionList = questionList;
			this.resultList = resultList;
			this.resultDesc = resultDesc;
		}

		getRawUserContentRow() {
			return (this.rawUserContent ?? "").split("\n").length;
		}

		getContentMemotyRow() {
			return (this.contentMemory ?? "").split("\n").length;
		}

		handleTextareaNextbreakForContent( e, target ) {
			// 필요 없을 것으로 예상
			console.log("handleTextareaNextbreakForContent N/A")
			/*
			const currentContext = e.target.value;
			const originContext = rawUserContent;
			const currentRows = currentContext.split("\n").length;
			const originRows = originContext.split("\n").length;
			if (originRows != currentRows) {
				updateRawUserContent()
			}
			*/
		}

/* // 필요할 지 체크
		changeRawUserContent( rawUserContent ) {
			if (this.rawUserContent === rawUserContent) return;
			this.rawUserContent = rawUserContent;
			this.updateRawUserContent();
		}
*/

		// FETCH API
		async onCreateContent() {
			try {

				console.log("CHEW : onCreateContent : this.rawUserContent :: ", this.rawUserContent)		
				
				// UPDATE RAW USER CONTENT, MEMORY
				await this.updateRawUserContent()
				await this.updateContentMemory()


				/**
				 * 기존 콘텐츠 모두 제거
				*/
				PRConnect.send("/api/Content/deleteOrganizedContent", {
					chatId: chat.chatId					
				}, data => {

					console.log("DELETE : data :: ", data)			

					PRConnect.send("/api/Content/fetchAnalyzeContentType", {
						chatId: chat.chatId,
						content : this.rawUserContent				
					}, data => {
				
						console.log("FETCH TYPE : data :: ", data)			
						const resultContentType = JSON.parse(data.result);					
				
						if( data.header.status === "success") {
							console.log("Analize Content type success : ", resultContentType.contentType );
							content.contentType = resultContentType.contentType

							PRConnect.send("/api/Content/fetchOrganizeContent", {
								chatId: chat.chatId,							
								contentType: this.contentType,
								content : this.rawUserContent				
							}, data => {
							
								// const receivedOrganized = JSON.parse( data );					
								// console.log("Organize Content success : ", data.result );

								this.contentSummary = data.result.summary;
								this.questionList 	= data.result.questions;
								this.resultList 	= data.result.resultList;
								this.resultDesc 	= data.result.resultDescription;							
								if ( this.contentSummary && this.questionList && this.resultList && this.resultDesc ) {
									console.log("ALL CONTENT ORGANIZED : ", this.questionList );
									isQuestionLoad = true;
								}

								// console.log("contentSummary : ", this.contentSummary );

								content.assign();
								refIframe.contentWindow.location.reload();

							});						
						}
					});

				});
				
				


			} catch ( error ) {
				console.error("ERROR : onCreateContent :: ", error);
			}
			
		}

		
		async updateRawUserContent() {
			console.log("CHEW : this.rawUserContent : ", this.rawUserContent);

			const param = {
				chatId: chat.chatId,				
				rawUserContent: this.rawUserContent,
			};

			try {
				const data = await new Promise((resolve, reject) => {
					PRConnect.send("/api/Content/insertRawUserContent", param, (response) => {
						if (response?.header?.status === "success") {
							resolve(response);
						} else {
							reject(new Error("API insertRawUserContent 실패"));
						}
					});
				});

				console.log("raw user content prompt update success");
				content.assign();
				// refIframe.contentWindow.location.reload();

			} catch (error) {
				console.error("raw user content update 실패:", error);
			}
		}

		async updateContentMemory() {
			console.log("CHEW : contentMemory : ", this.contentMemory )
			const param = {
				chatId : chat.chatId,				
				memory : this.contentMemory,
			}
			content.assign();
			try {
				const data = await new Promise((resolve, reject) => {
					PRConnect.send("/api/Content/insertContentMemory", param, (response) => {
						if( response?.header?.status === "success") {
							resolve( response )
						} else {
							reject(new Error("API insertContentMemory 실패"));
						}
					});						
				});

				console.log("content memory update success");
				content.assign();
				// refIframe.contentWindow.location.reload();

			} catch (error) {
				console.error("insertContentMemory 실패:", error);
			}
			
		}

		handleChange(event) {
			const targetName = event.target.name;
			const targetValue = event.target.value;
    		console.log("Changed : name :: ", targetName, " value :: ", targetValue);
    		// 실제 처리 로직 작성 가능
			autoResize(event.target);

			const chatId = chat.chatId;			
			const contentType = this.contentType;			

			if ( targetName == "summary" ) {			
				PRConnect.send("/api/Content/updateContentSummary", {chatId, contentType, summary:targetValue }, (response) => {
					console.log("Changed : response :: ", response );
				});
			} else if ( targetName == "inquery" ) {			
				const selectedIndex = parseInt( event.target.dataset.index )
				console.log("Changed : ", targetName, ", index :: ", selectedIndex );				
				if ( this.questionList ) {
					const selectedQuestionInfo = this.questionList[selectedIndex]					
					selectedQuestionInfo.chatId = chatId;					

					console.log("SELECTED QUESTION INFO : ", selectedQuestionInfo );

					PRConnect.send("/api/Content/updateContentQuestions", selectedQuestionInfo, (response) => {
						console.log("Changed : response :: ", response );
					});
					
				} else {
					console.log("QUESTION LIST IS NULL" );					
				}
					
				// console.log("QUESTION INFO : ", this.questionList[selectedIndex] );
				
			} else if ( targetName == "result" ) {			
				const selectedIndex = parseInt( event.target.dataset.index )
				console.log("Changed : ", targetName, ", index :: ", selectedIndex );				
				if ( this.resultList ) {
					const selectedResultInfo = this.resultList[selectedIndex]					
					console.log("SELECTED RESULT INFO : ", selectedResultInfo );

					PRConnect.send("/api/Content/updateContentResults", selectedResultInfo, (response) => {
						console.log("Changed : response :: ", response );
					});
					
				} else {
					console.log("RESULT LIST IS NULL" );					
				}
					
				// console.log("QUESTION INFO : ", this.questionList[selectedIndex] );
				
			} else if ( targetName == "resultDescription" ) {
				PRConnect.send("/api/Content/updateContentSummary", {chatId, contentType, resultDesc:targetValue }, (response) => {
					console.log("Changed : response :: ", response );
				});
			}

  		}

		assign() {
			content = content;
		}

	}

	function autoResize( textarea ) {
		textarea.style.height = 'auto';
		textarea.style.height = textarea.scrollHeight + 'px';
	}

</script>
{#if content}
<div class="chat-contents-wrap first">
	<div class="div-block-115">
		<div class="chat-h2">콘텐츠의 내용을 입력해 주세요!</div>						
	</div>
	<div class="linktext-input-form-copy w-form">
		<div id="email-form" name="email-form" data-name="Email Form" method="get" class="l-link-form"> 
			<textarea class="c-info-text-form w-input" rows={content.getRawUserContentRow()} name="name-4" data-name="Name 4" placeholder="<문구 예시>만들고자 하는 콘텐츠의 내용을 작성해주세요!" id="name-4" bind:value={ content.rawUserContent} on:change={(e)=>content.updateRawUserContent()} on:input={(e)=>content.handleTextareaNextbreakForContent(e, "rawUserContent")} />
		</div>
	</div>
	<div class="div-block-115">
		<div class="chat-h2">반드시 기억해야할 내용을 입력해 주세요!</div>						
	</div>
	<div class="linktext-input-form-copy w-form">
		<div id="email-form" name="email-form" data-name="Email Form" method="get" class="l-link-form"> 
			<textarea class="c-info-text-form w-input" rows={content.getContentMemotyRow()} name="name-4" data-name="Name 4" placeholder="<문구 예시>첫 인삿말, 콘텐츠의 결과안내 등 꼭 기억해야 할 내용을 입력해 주세요! (1000자 이내)" id="name-4" bind:value={content.contentMemory} on:change={(e)=>content.updateContentMemory()} on:input={(e)=>content.handleTextareaNextbreakForContent(e, "contentMemory")} />
		</div>
	</div>

	<div class="key-word priority">
		<div class="keyword-plus pointer" on:click={()=> content.onCreateContent()}>콘텐츠 생성</div>
	</div>
	{#if isQuestionLoad == true}
<!-- Summary -->
	<div class="block">
  		<div class="section-title">Summary</div>
  		<div class="l-link-form">
			<textarea 
				class="c-info-text-form w-input" 
				name="summary" 			
				bind:value={ content.contentSummary } 
				on:change={ (e) => {      				
						content.handleChange(e);
					}} 			
			/>
		</div>
	</div>
<!-- Question List -->
	<div class="block">
  		<div class="section-title">Questions</div>
  		{#each content.questionList as question, idx}
    	<div class="question">
      		<div><strong>#{idx + 1}.</strong></div>
      		<input class="content-builder-textarea" type="text" name={`inquery`} data-index={idx} bind:value={ question.inquery } on:change={(e) => content.handleChange(e)} placeholder="질문" />
      		<textarea class="content-builder-textarea" name={`inquery`} data-index={idx} bind:value={question.inqueryDesc} on:change={(e) => content.handleChange(e)} rows="2" placeholder="설명" />
      		<input class="content-builder-textarea" type="text" name={`inquery`} data-index={idx} bind:value={ question.deductiveLogic } on:change={(e) => content.handleChange(e)} placeholder="deductiveLogic" />
      		<div style="margin-top: 0.5rem;">Options:</div>
      		{#each question.options as option, optIdx}
  			<input
    			class="content-builder-textarea option"
    			type="text"
    			name={`inquery`}
				data-index={idx}				
    			value={option}
    			on:change={(e) => {
      				question.options[optIdx] = e.target.value;
      				question.options = [...question.options]; // 배열 자체를 갱신해서 반응성 보장
      				content.handleChange(e); // 기존 핸들러 호출
    			}}
    			placeholder={`Option ${optIdx + 1}`}
  			/>
{/each}
    	</div>
  		{/each}
	</div>
<!-- Result List -->
	<div class="block">
  		<div class="section-title">Result Types</div>
  		{#each content.resultList as result, idx}
    	<div class="result">
      	<input class="content-builder-textarea" type="text" name={`result`} data-index={idx} bind:value={ result.result } on:change={(e) => content.handleChange(e)} placeholder="결과 유형 (예: E, I, N...)" />
      	<textarea class="content-builder-textarea" name={`result`} data-index={idx} bind:value={ result.resultDesc } on:change={(e) => content.handleChange(e)} rows="2" placeholder="결과 설명" />
    	</div>
  		{/each}
	</div>

<!-- Result Description -->
	<div class="block">
  		<div class="section-title">Result Description</div>
  		<textarea class="content-builder-textarea" name="resultDescription" bind:value={ content.resultDesc } on:change={(e) => content.handleChange(e)} rows="3" />
	</div>
	{/if}
</div>
{/if}
<style>

	/* QUESTIONS */
	.block {
    	border: 1px solid hsl(var(--sb-border));
    	border-radius: 10px;
    	padding: 1rem;
    	margin-bottom: 1.5rem;
    	background-color: hsl(var(--sb-muted) / 0.4);
  	}

  	.section-title {
	    font-weight: bold;
    	margin-bottom: 0.5rem;
    	font-size: 1.2rem;
  	}

  	.question, .result {
    	border-bottom: 1px solid hsl(var(--sb-border));
    	padding: 0.5rem 0;
  	}
  	
	.content-builder-textarea {
		width: 100%;
		font-size: 1rem;
		margin-top: 0.3rem;
		padding: 0.3rem;
		border-radius: 6px;
		border: 1px solid hsl(var(--sb-border));		
	}

	.content-builder-textarea {
		resize: vertical;
	}

  	.option {
    	margin-left: 1rem;
    	margin-bottom: 0.3rem;
  	}
	/* QUESTIONS END */

	.div-block-115 {
		overflow: initial;
	}

	.chat-contents-wrap {
		margin-right: 0px;
		justify-content: space-between;
	}

	.chat-contents-wrap.last {
		padding: 10px;
	}
	
	@media screen and (min-width: 1280px) {		
		.chat-contents-wrap.first {
			padding: 10px;
    	}
	}

	@media screen and (max-width: 479px) {
		.c-info-text-form {
			width: 100%;
		}		
		.chat-contents-wrap.persona-option-wrap {
			margin-bottom: 0px;
		}

	}

</style>